import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";
const RESOURCE_NAME = "/api/employee_notifications";

export default {
  async getAllNotifications(params) {
    return await Api()
      .get(RESOURCE_NAME, { params })
      .catch((err) => errorHandler(err, null));
  },
  async getEmployeeNotifications(id) {
    return await Api()
      .get(RESOURCE_NAME + "/" + id)
      .catch((err) => errorHandler(err, null));
  },
  //No API
  //   async postNotification(params) {
  //     return await Api()
  //       .post(RESOURCE_NAME, params)
  //       .catch((err) => errorHandler(err, null));
  //   },
  // async deleteProvider(id) {
  //   return await Api()
  //     .delete(RESOURCE_NAME + "/" + id)
  //     .catch((err) => errorHandler(err, null));
  // },
  async updateEmployeeNotification(id, params) {
    return await Api()
      .put(RESOURCE_NAME + "/" + id, params)
      .catch((err) => errorHandler(err, null));
  },
  async archiveEmployeeNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/archive")
      .catch((err) => errorHandler(err, null));
  },
  async unarchiveEmployeeNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/unarchive")
      .catch((err) => errorHandler(err, null));
  },
  async pinEmployeeNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/pin")
      .catch((err) => errorHandler(err, null));
  },
  async unpinEmployeeNotification(id) {
    return await Api()
      .post(RESOURCE_NAME + "/" + id + "/unpin")
      .catch((err) => errorHandler(err, null));
  },
  async patchEmployeeNotification(id, params) {
    return await Api()
      .put(RESOURCE_NAME + "/" + id, params)
      .catch((err) => errorHandler(err, null));
  },
  async markAllNotificationsAsRead() {
    return await Api()
      .post("/api/notifications/mark_all_as_read")
      .catch((err) => errorHandler(err, null));
  },
};
